<template>
  <v-layout
    wrap
    align-center
    purchase
  >
    <v-flex xs3>
      <v-img
        :src="application.image || require('@/images/no-image.png')"
        max-width="50"
      />
    </v-flex>
    <v-flex
      xs9
      pl-1
    >
      <b>{{ application.name }}</b>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "ApplicationPurchase",
  props: {
    application: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {};
  },
  methods: {
    selectedItemDesc: function (desc) {
      if (desc) {
        return desc.split(/\n/);
      }
      return [];
    },
  },
};
</script>

<style lang="scss" scoped>
.tariff-description {
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 20px;
  li {
    font-weight: 400;
    font-size: 13px;
    text-align: left;
    line-height: 130%;
    color: var(--color-primary-text);
    padding: 0 30px 0 0;
    position: relative;
  }
}
</style>
